import { React, useState, useEffect } from "react";
import AOS from "aos";

import { DashLg, PlusLg } from "react-bootstrap-icons";

const Faq = ({ faq }) => {
  const [openFaq, setOpenFaq] = useState(false);
  const [closeAnswer, setCloseAnswer] = useState(false);

  const fontSize = {
    fontSize: "1.17rem",
  };

  const faqHandler = () => {
    setOpenFaq(!openFaq);

    setCloseAnswer(!closeAnswer);
  };
  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);
  return (
    <div data-aos="fade-right">
      <hr />
      <div className="faq-info d-flex justify-content-between align-items-center text-start">
        <h6 className="" style={fontSize}>
          {faq.ques}
        </h6>
        <div className="position-relative openFaq" onClick={faqHandler}>
          {openFaq ? (
            <button
              type="button"
              className="border-0 bg-white"
              data-bs-toggle="collapse"
              href="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              <DashLg className="fw-bolder fs-4" />
            </button>
          ) : (
            <button
              type="button"
              className="border-0 bg-white"
              data-bs-toggle="collapse"
              href="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              <PlusLg className="fw-bolder fs-4" />
            </button>
          )}
        </div>
      </div>
      <div id="collapseExample" className="collapse">
        {closeAnswer && <p className="my-2 pt-2 text-start">{faq.ans}</p>}
      </div>
    </div>
  );
};

export default Faq;
